import React from 'react'
import moment from 'moment'
import { Row, Col, Typography, Card, List, Divider, Collapse, Badge, Checkbox } from 'antd'

import 'moment/locale/es'

import { useFirebase } from '../firebaseContext'
import { useRedux } from '../redux'

const { Title, Text } = Typography
const { Panel } = Collapse

export default function Messages() {
  const [items, setItems] = React.useState([])
  const [index, setIndex] = React.useState(-1)
  const firebase = useFirebase()
  const actions = useRedux()

  React.useEffect(() => {
    actions.setAppLoading(true)
    const ref = firebase.getCollectionRef('messages').orderBy('created', 'desc').limit(50)
    const unsuscribe = ref.onSnapshot(async snap => {
      let array = []
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(async doc => {
        const data = doc.data()
        const user = await data.user.get()
        const item = { id: doc.id, ...data, user: user.data() }
        array.push(item)
      }))
      setItems(array)
      actions.setAppLoading(false)
    })
    return () => {
      unsuscribe()
    }
  }, [])

  const handleRead = (i, id) => {
    setIndex(i)
    firebase.getDocRef('messages', id).update({ read: true })
  }

  return (
    <div>
      <Title level={2}>Mensajes</Title>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <Card>
            {items && index>=0 && <React.Fragment>
              <Row>
                <Col span={24} style={{display: 'flex', justifyContent: 'flex-end'}}>
                  <Text>{`${moment(items[index].created.toDate()).format('DD MMMM YYYY, h:mm a')} (${moment(items[index].created.toDate()).fromNow()})`}</Text>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Title level={5}>{items[index].subject}</Title>
                </Col>
              </Row>
              <Collapse defaultActiveKey="1" expandIconPosition="right" ghost>
                <Panel header="" key="1">
                  <Row>
                    <Col span={24}>
                      <Row>
                        <Col span={4} style={{fontWeight: 'bold', paddingRight: 10}}>
                          <Text>De:</Text>
                        </Col>
                        <Col span={20}>
                          <Text>{items[index].user.email}</Text>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={4} style={{fontWeight: 'bold', paddingRight: 10}}>
                          <Text>Nombre:</Text>
                        </Col>
                        <Col span={20}>
                          <Text>{items[index].user.first_name} {items[index].user.last_name}</Text>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={4} style={{fontWeight: 'bold', paddingRight: 10}}>
                          <Text>Teléfono:</Text>
                        </Col>
                        <Col span={20}>
                          <Text>{items[index].user.phone_number}</Text>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
              <Divider />
              <Row>
                <Col span={24}>
                  <Text>{items[index].content}</Text>
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col span={24} style={{display: 'flex', justifyContent: 'flex-end'}}>
                  ¡Quiere que lo contacten! <Checkbox checked={items[index].contact} style={{marginLeft: 10}} />
                </Col>
              </Row>
            </React.Fragment>}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={8}>
          <List
            size="small"
            className="blist"
            dataSource={items}
            renderItem={(item, i) => (
              <List.Item actions={!(item.read && item.read == true) && [<Badge count="Nuevo"></Badge>]} className="btn" onClick={() => handleRead(i, item.id)}>
                <List.Item.Meta
                  title={item.subject}
                  description={item.user.email}
                />
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </div>
  )
}
